import React, {Component} from 'react'
import RegistrationSplash from './RegistrationSplash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

const mapStateToProps = (state) => {
  return {
    areas: state.area,
    addresses: state.address
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    /* areaActions: bindActionCreators(areaActions, dispatch),
    categoriesActions: bindActionCreators(categoriesActions, dispatch),
    addressActions: bindActionCreators(addressActions, dispatch),
    registrationActions: bindActionCreators(registrationActions, dispatch) */
  }
}

class RegistrationSplashContainer extends Component {
  render () {
    return (<RegistrationSplash />)
  }
}

export default connect(
  mapStateToProps, mapDispatchToProps
)(RegistrationSplashContainer)



// WEBPACK FOOTER //
// ./src/containers/Registration/Splash/RegistrationSplashContainer.js